import type { FC, HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.EngagementRow';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const EngagementRow: FC<Props> = ({ className, children, ...props }) => (
  <div className={twMerge('inline-flex items-center gap-[1px] pt-[6px]!', className)} {...props}>
    {children}
  </div>
);

EngagementRow.displayName = DISPLAY_NAME;
